import { useCallback } from "react"
import { useAxiosInstances } from "../../axios-instance"
import { IListaDeduplicacao } from "../../../application/models"

export const useListaDeduplicacaoApi = () => {
    const { axiosAuthInstance } = useAxiosInstances()

    const createListaDeduplicacaoApi = useCallback(async (data: {
        Nome: string
        IdUsuario: number
    }): Promise<IListaDeduplicacao> => {
        try {
            const result = await axiosAuthInstance.post('/geo-veles/lista-deduplicacao/', {
                IdUsuario: data.IdUsuario,
                Nome: data.Nome
            })

            return result.data.listaDeduplicacao
        } catch (error) {
            throw error
        }

    }, [axiosAuthInstance])

    const findListaDeduplicacaoByIdApi = useCallback(async (data: {
        IdVelesGeoListaDeduplicacao: number
    }): Promise<IListaDeduplicacao> => {
        try {
            const result = await axiosAuthInstance.get(`/geo-veles/lista-deduplicacao/${data.IdVelesGeoListaDeduplicacao}`)

            return result.data.listaDeduplicacao
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    const findListasDeduplicacaoApi = useCallback(async (data: {
        IdUsuario: number
    }): Promise<IListaDeduplicacao[]> => {
        try {
            const result = await axiosAuthInstance.get('/geo-veles/lista-deduplicacao/', {
                params: {
                    IdUsuario: data.IdUsuario
                }
            })

            return result.data.listasDeduplicacao
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    const updateListaDeduplicacaoApi = useCallback(async (data: {
        IdVelesGeoListaDeduplicacao: number
        CPFs: string[]
        Nome: string
    }): Promise<IListaDeduplicacao> => {
        try {
            const result = await axiosAuthInstance.put('/geo-veles/lista-deduplicacao/cpfs', {
                IdVelesGeoListaDeduplicacao: data.IdVelesGeoListaDeduplicacao,
                CPFs: data.CPFs,
                Nome: data.Nome
            })

            return result.data.listaDeduplicacao
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    const updateListaDeduplicacaoStatusApi = useCallback(async (data: {
        IdVelesGeoListaDeduplicacao: number
        Status: boolean
    }): Promise<IListaDeduplicacao> => {
        try {
            const result = await axiosAuthInstance.put('/geo-veles/lista-deduplicacao/status', {
                IdVelesGeoListaDeduplicacao: data.IdVelesGeoListaDeduplicacao,
                Status: data.Status
            })

            return result.data.listaDeduplicacao
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    return {
        createListaDeduplicacaoApi,
        findListaDeduplicacaoByIdApi,
        findListasDeduplicacaoApi,
        updateListaDeduplicacaoApi,
        updateListaDeduplicacaoStatusApi
    }
}